import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import MaterialUsage34_1aTable from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const MaterialUsage34_1a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("MATERIAL_USAGE") || "Material Usage"}
        subDescription={
          t("MATERIAL_USAGE_34_1A_DESC") ||
          "Enter material usage for custom manufacturing"
        }
        isNormal={true}
        number={"34.1a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`material-usage-34-1a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <MaterialUsage34_1aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default MaterialUsage34_1a;
